import { createSlice } from "@reduxjs/toolkit";

export const circleSlice = createSlice({
  name: "userCircles",
  initialState: {
    circles: {},
    loading: false,
    error: null,
  },
  reducers: {
    setCircles: (state, action) => {
      state.circles = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setCircles, setLoading, setError } = circleSlice.actions;

export default circleSlice.reducer;
